import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_485: DocMigration = {
  maxSchemaVersion: "0.0.485",
  description: "Break up sheet geometry categories to support proper styling",
  apply(json: any) {
    if (!json.viewTemplates) {
      return json;
    }

    for (const templateId in json.viewTemplates) {
      const template = json.viewTemplates[templateId];

      let categoryReplaceMap: Record<string, string[]> | undefined;

      if (template.viewType === "PLAN_VIEW") {
        categoryReplaceMap = planReplaceCategoriesMap;
      } else if (template.viewType === "ELEVATION_VIEW") {
        categoryReplaceMap = elevationReplaceCategoriesMap;
      }

      if (!categoryReplaceMap) {
        continue;
      }

      const newCategories: Set<string> = new Set();

      for (const category of template.categories) {
        if (categoryReplaceMap[category]) {
          for (const newCategory of categoryReplaceMap[category]) {
            newCategories.add(newCategory);
          }
        } else {
          newCategories.add(category);
        }
      }

      template.categories = Array.from(newCategories);

      const newStyleOverrides: Record<string, object> = {};

      for (const category in template.styleOverrides) {
        if (categoryReplaceMap[category]) {
          for (const newCategory of categoryReplaceMap[category]) {
            newStyleOverrides[newCategory] = template.styleOverrides[category];
          }
        } else {
          newStyleOverrides[category] = template.styleOverrides[category];
        }
      }

      template.styleOverrides = newStyleOverrides;
    }

    return json;
  },
};

const planReplaceCategoriesMap: Record<string, string[]> = {
  WAINSCOTING: ["WAINSCOTING_CUT", "WAINSCOTING_PROJECTED"],
  CASEWORK_SOLID_DASH: ["CASEWORK"],
  CASEWORK_POCHE: ["CASEWORK"],
  STAIR: ["STAIR_ABOVE", "STAIR_PROJECTED"],
  STAIR_CROSS_SECTION: ["STAIR_WALLS"],
  BRICKLEDGE: ["BRICKLEDGE_CUT", "BRICKLEDGE_PROJECTED"],
  RAILING: ["RAILING_PROJECTED", "RAILING_ABOVE"],
  RAILING_STAIR_ONLY: ["RAILING_PROJECTED_STAIR_ONLY", "RAILING_ABOVE_STAIR_ONLY"],
};

const elevationReplaceCategoriesMap: Record<string, string[]> = {
  TOP_OF_PLATE_ANNOTATION: ["TOP_OF_PLATE_MARKERS", "TOP_OF_PLATE_DIMENSIONS"],
};

export default migration_0_0_485;
